import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { CommentSyncEventViewerComponent } from './comment-sync-event-viewer.component';

export const ngxCommentSyncEventViewerModule = angular.module('ngxCommentSyncEventViewerModule', [])
	.directive('ngxCommentSyncEventViewer', downgradeComponent({ component: CommentSyncEventViewerComponent }))
	.name;
